import * as React from 'react'
import Typography from '@mui/material/Typography'
import { InputProps } from 'ra-core'

export const TwoColumnInput: React.FC<{ title?: string; description?: string }> = (props) => {
  const { title, description, children } = props

  return (
    <label
      style={{
        display: 'flex',
        flexFlow: 'row wrap',
        height: '100%',
        width: '100%',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        paddingTop: '10px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexFlow: 'column nowrap',
          flex: '1 0',
          // padding: 10
        }}
      >
        <Typography variant="h6" component="h1">
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </div>
      <div
        style={{
          paddingTop: 15,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          flex: '1 0',
          justifyContent: 'center',
        }}
      >
        {children}
      </div>
    </label>
  )
}
